var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResetPasswordLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.65801 8.62347L5.64414 6.95686C5.62119 4.19862 6.43584 1.9501 10.6024 1.91543C14.7689 1.88075 15.6208 4.11541 15.6438 6.87365L15.6577 8.54026",
    stroke: "#6A6077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9075 18.547L6.57444 18.6164C3.24122 18.6441 2.40098 17.8177 2.37325 14.4845L2.35938 12.8179C2.33164 9.48467 3.15801 8.64443 6.49123 8.6167L14.8243 8.54735C18.1575 8.51962 18.9977 9.34599 19.0255 12.6792L19.0393 14.3458C19.0671 17.679 18.2407 18.5193 14.9075 18.547Z",
    stroke: "#6A6077",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0298 13.5538L14.0373 13.5538",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6958 13.5822L10.7033 13.5821",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.36159 13.6095L7.36907 13.6094",
    stroke: "#292D32",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResetPasswordLock);
export default __webpack_public_path__ + "static/media/resetPasswordLock .04f344a0a2111e42cd96286528b5f452.svg";
export { ForwardRef as ReactComponent };